import slugify from 'slugify';

export default function filterMethod(countries, filterValue) {
  if (filterValue !== '') {
    return countries.filter((option) => {
      const normalizedValue = slugify(option.value, {
        replacement: ' ',
        lower: true,
      });

      const normalizedQuery = slugify(filterValue, {
        replacement: ' ',
        lower: true,
      });

      return normalizedValue.includes(normalizedQuery);
    });
  }
  return countries;
}
